import styled from 'styled-components';
import { text_s, svg } from '_utils/styles';

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const DirectionsLink = styled.a`
  color: inherit;

  ${text_s}
  &:hover {
    ${({ theme }) => theme.colors.link.secondary.colorHover};
  }
`;

export const ArrowIconWrap = styled.span`
  ${svg(17, 17)}
  flex: none;
  width: 17px;
  margin: 0 10px 0 0;
  path {
    fill: ${({ theme }) => theme.card.attributeIcon};
  }
`;

export const ExternalIconWrap = styled.span`
  ${svg(13, 13)}
  flex: none;
  width: 13px;
  margin: 0 0 0 10px;
  path {
    fill: ${({ theme }) => theme.card.attributeIcon};
  }
`;
